module.exports = require("stream");


//////////////////
// WEBPACK FOOTER
// external "stream"
// module id = 324
// module chunks = 0